module.exports = __webpack_public_path__ + "static/media/booking-logo-icon-1.2fb8e242.webp";